module.exports = __webpack_public_path__ + "img/carousel1QS.a3d91bed.jpg";